import React from 'react';
import TierGrid from '../TierGrid';
import PopupInnerLayout from '../../_partials/PopupInnerLayout';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import { useTiers } from '../../_hocs/withTiers';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import SelectableDeviationWrapper from '../../_partials/SelectableDeviationWrapper';
import { getDeviationEntityId } from '../../../redux/normalizr/schemas/deviation';
import TierPromotionCardSemiDumb from '../../../DeviationViews/TierPromotionCardSemiDumb';

export interface Props {}

const TierSelector: React.FC<Props> = () => {
  const { tiers, isTierStreamInitialized, isFetchingTiers } = useTiers();

  const renderTier = ({ index, width }) => {
    const tier = tiers[index];

    return (
      <SelectableDeviationWrapper key={getDeviationEntityId(tier)} deviation={tier}>
        <TierPromotionCardSemiDumb width={width} deviation={tier} ctaButton="view-subscribe" />
      </SelectableDeviationWrapper>
    );
  };

  const renderContent = () => {
    return (
      <>
        {isTierStreamInitialized && (
          <TierGrid
            cookieType={MeasuredCookieType.GALLECTION_EXPLORER}
            tiers={tiers}
            tierRenderer={renderTier}
            isTierPromotion
          />
        )}
        {isFetchingTiers && <LoadingIndicator view="daSymbol" coverMode={!tiers.length} />}
      </>
    );
  };

  return <PopupInnerLayout scrollableContent={renderContent()} />;
};
TierSelector.displayName = 'TierSelector';

export default TierSelector;
